module.exports = __webpack_public_path__ + "media/images/pc/stores/tachikawa/tachikawa_concept_01-e92ba6144ffe4fc437365000c26230d0.jpg";